import { Component } from '@angular/core';

@Component({
  selector: 'bridge-settings-dialog',
  templateUrl: './bridge-settings-dialog.component.html',
  styleUrls: ['./bridge-settings-dialog.component.scss'],
})
export class BridgeSettingsDialogComponent {}
